import { compose, withState, withProps, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { setReturningUser as setReturningUserAction } from '../../../../core/auth';
import { fetchUsersInfo } from '../../../../core/app/util';
import { checkUserSession } from '../../../../core/auth/util';
import { LocalStorage, retrieveUriParam } from '../../../../utils/helpers';

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setReturningUser: setReturningUserAction }, dispatch);

export default compose(
  connect(({ authentication: { returningUser } }) => ({ returningUser }), mapDispatchToProps),
  withState('credentials', 'setcredentials', { username: '', password: '' }),
  withState('useAnotherAccount', 'setUseAnotherAccount', false),
  withState('submitting', 'setSubmitting', false),
  withState('usersInfo', 'setUsersInfo', {}),
  withState('usersTokens', 'setUsersTokens', {}),
  withState('users', 'setUsers', []),
  withState('removeAccounts', 'setRemoveAccounts', false),
  withState('buttonText', 'setButtonText', 'SIGN ON'),
  withProps({ registerUri: retrieveUriParam('register_uri') }),
  withHandlers({
    handleOnLogin: ({
      onSubmit,
      setButtonText,
      returningUser,
      message,
      setSubmitting,
      clearMessage
    }) => ({ username, password }, { change }, callback) => {
      setButtonText('SIGNING ON...');
      setSubmitting(true);
      clearMessage();
      onSubmit({
        username: (returningUser && returningUser.email) || username,
        password,
        onFailure: () => {
          change('password', '');
          callback({ password: (message && message.text) || 'LoginError' });
        }
      });
    },
    toggleUseAnotherAccount: ({ setUseAnotherAccount }) => () => setUseAnotherAccount(n => !n),
    returningLogin: ({ setReturningUser }) => ({ firstName, email }) => {
      setReturningUser({ firstName, email });
    },
    onBack: ({ setReturningUser, clearMessage }) => () => {
      setReturningUser({ email: null, firstName: null });
      clearMessage();
    },
    toggleRemoveAccounts: ({ setRemoveAccounts }) => () => setRemoveAccounts(s => !s),
    removeAccount: ({ setUsers, setUsersTokens }) => email => {
      setUsers(users => {
        const newUsers = users.filter(u => u !== email);
        LocalStorage.setObject('usernames', newUsers);
        return newUsers;
      });
      setUsersTokens(usersTokens => {
        const newUsersTokens = { ...usersTokens };
        delete newUsersTokens[email];
        LocalStorage.setObject('usersTokens', newUsersTokens);
        return newUsersTokens;
      });
    }
  }),
  lifecycle({
    async componentDidMount() {
      const { setUsers, setUsersInfo, setUsersTokens } = this.props;

      const users = LocalStorage.getArray('usernames');
      setUsers(users);

      await checkUserSession();
      const usersTokens = await checkUserSession();
      setUsersTokens(usersTokens);

      const usersInfo = await fetchUsersInfo(users);
      setUsersInfo(usersInfo);
    },
    componentWillUpdate(nextProps) {
      if (nextProps.message && nextProps.message !== this.props.message) {
        this.props.setButtonText('SIGN ON');
        this.props.setSubmitting(false);
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/views/common/containers/LoginEnhancer/index.jsx